import React, { ReactNode } from "react";
import { isFunction } from "lodash";

export interface DraggableRowContentProps {
	children?: ReactNode;
}

const DraggableRowContent: React.FC<DraggableRowContentProps> = ({ children }) => {
	return <div className={`draggable-row-content`}>{isFunction(children) ? children() : children}</div>;
};

export default DraggableRowContent;
